var StrFormatter = Object.create(null),
    _ = require('lodash'),
    cheerio = require('cheerio');

StrFormatter.formatStr = formatStr;
StrFormatter.htmlToStr = htmlToStr;
StrFormatter.formatLastnameOrFirstname = formatLastnameOrFirstname;
StrFormatter.shortStr = shortStr;
StrFormatter.shortMoreStr = shortMoreStr;
StrFormatter.encryptId = encryptId;
StrFormatter.decryptId = decryptId;
StrFormatter.isEncrypted = isEncrypted;
StrFormatter.getGender = getGender;
StrFormatter.capitalizeFirstLetter = capitalizeFirstLetter;
StrFormatter.formatStrForAccountingExport = formatStrForAccountingExport;
StrFormatter.replaceAccents = replaceAccents;
StrFormatter.btoa = btoa;
StrFormatter.atob = atob;
StrFormatter.getFormattedModelNameInUrl = getFormattedModelNameInUrl;
StrFormatter.encodeStr = encodeStr;
StrFormatter.decodeStr = decodeStr;
StrFormatter.generateRandomString = generateRandomString;
StrFormatter.isEmail = isEmail;

/**
 * Permet de formatter une chaîne de caractère avec possiblement des balises HTML en précisant une taille maximum
 * @param {string} content - Contenu à formatter avec les balises HTML
 * @param {?number} [size=null] - Taille du texte à afficher
 * @returns {string}
 * TU DONE 🗸
 */
// eslint-disable-next-line complexity
function formatStr(content, size = null) {
  var text = '',
      $, cheerioSelector, cheerioText;

  if (content) {
    $ = cheerio.load(content);
    cheerioSelector = $('p, div, ul, th, td');
    if (cheerioSelector.length > 0) {
      cheerioText = cheerioSelector.text();
      text = size && cheerioText.length > size ? `${ cheerioText.substr(0, size) }...` : cheerioText;
    } else {
      text = size && content.length > size ? `${ content.substr(0, size) }...` : content;
    }
  }

  return text || content;
}

/**
 * Permet de formatter une chaîne de caractère avec des balises HTML en texte brut
 * @param {string} content - Contenu à formatter avec les balises HTML
 * @returns {string}
 * TU DONE 🗸
 */
function htmlToStr(content) {
  var text = '',
      $;

  if (content) {
    $ = cheerio.load(content);
    text = $.text();
  }

  return text || content;
}

/**
 * Permet de formatter un prénom ou un nom
 * @param {string} string - Chaîne à formatter
 * @returns {string} La chaîne formatté
 * TU DONE 🗸
 */
function formatLastnameOrFirstname(string) {
  var stringArray, formattedStringArray, formattedString;

  if (string) {
    stringArray = string.replace(/(\s)+/g, ' ')
      .split(' ');
    formattedStringArray = stringArray.reduce((array, string) => {
      var lowerCaseString = string.toLowerCase();

      array.push(lowerCaseString.charAt(0).toUpperCase() + lowerCaseString.slice(1));
      return array;
    }, /** @type {Array<string>}*/([]));
    formattedString = formattedStringArray.join(' ')
      .trim();
  } else {
    formattedString = string;
  }

  return formattedString;
}

/**
 * Permet de formatter une chaîne de caractère avec une taille maximum
 * @param {string} content - Contenu à formatter
 * @param {number} size - Taille du texte à afficher
 * @returns {string} - Chaîne formattée
 * TU DONE 🗸
 */
function shortStr(content, size) {
  if (content) {
    var shortStr = content.substr(0, size);

    return content.length > size ? `${ shortStr }...` : shortStr;
  } else {
    return 'Aucun contenu.';
  }
}

/**
 * Permet de formatter une chaîne de caractère avec une taille maximum et d'afficher un bouton pour voir la suite
 * @param {string} content - Contenu à formatter
 * @param {number} size - Taille du texte à afficher
 * @returns {string} - Chaîne formattée en HTML
 * TU DONE 🗸
 */
function shortMoreStr(content, size) {
  var shortStr;

  if (content) {
    if (content.length > size) {
      shortStr = '<div class="shortstr">';
      shortStr += `<div class="shortstr__reduce">${ StrFormatter.formatStr(content, size) }</div>`;
      shortStr += `<div class="shortstr__expand is-hidden">${ content }</div>`;
      shortStr += '<button data-tooltip="Voir plus" class="shortstr__button"><span class="icon material-symbols-outlined">expand_content</span></button>';
      shortStr += '</div>';
    } else {
      shortStr = StrFormatter.formatStr(content);
    }
  } else {
    shortStr = 'Aucun contenu.';
  }
  return shortStr;
}

/**
 * Encode une chaîne en Base64 en y ajoutant une clé d'environnement.
 * Ce mécanisme n'est PAS un chiffrement sécurisé.
 * Il s'agit simplement d'un encodage Base64 avec concaténation d'une clé.
 * @param {number} id Identifiant à crypter
 * @returns {string} Identifiant encrypter
 * TU NONEED 🧊
 */
function encryptId(id) {
  var buffer = Buffer.from((`${ id }-${ process.env.ENCRYPTION_KEY }`).toString());

  return buffer.toString('base64');
}

/**
 * Décode une chaîne Base64 précédemment encodée avec encryptStr.
 * @param {string} id Identifiant à crypter
 * @returns {number} Identifiant decrypter
 * TU NONEED 🧊
 */
function decryptId(id) {
  var buffer = Buffer.from(id, 'base64');

  return parseInt(buffer.toString('ascii').split('-')[0], 10);
}

/**
 * Permet de vérifier si une chaîne est en base64
 * @param {string} str - Chaîne à vérifier
 * @returns {boolean} - True si la chaîne est en base64, false sinon
 */
function isEncrypted(str) {
  var base64Regex = /^[A-Za-z0-9+/=]+$/;

  return (
    typeof str === 'string'
    && str.length % 4 === 0
    && base64Regex.test(str)
  );
}

/**
 * Permet de récupérer le genre d'une personne
 * @param {string} gender - Genre de la personne au format str de taille 1 dans la base de données
 * @returns {?string} Genre de la personne
 * TU DONE 🗸
 */
function getGender(gender) {
  if (!gender) {
    return null;
  }
  return gender === 'h' ? 'Homme' : 'Femme';
}

/**
 * Permet de mettre la première lettre d'une chaîne en majuscule
 * @param {string} string - Chaîne à formatter
 * @returns {string} - Chaîne formattée
 * TU DONE 🗸
 */
function capitalizeFirstLetter(string) {
  string = string?.toLowerCase();
  return string ? string.charAt(0).toUpperCase() + string.slice(1) : '';
}

/**
 * Remplace les accents dans une chaîne de caractère
 * @param {string} str - Chaîne de caractère à formater
 * @returns {string}
 * TU DONE 🗸
 */
function replaceAccents(str) {
  var accentCorrespondence = {
        à: 'a',
        á: 'a',
        â: 'a',
        ä: 'a',
        å: 'a',
        æ: 'ae',
        ç: 'c',
        è: 'e',
        é: 'e',
        ê: 'e',
        ë: 'e',
        ì: 'i',
        í: 'i',
        î: 'i',
        ï: 'i',
        ð: 'd',
        ñ: 'n',
        ò: 'o',
        ó: 'o',
        ô: 'o',
        ö: 'o',
        ù: 'u',
        ú: 'u',
        û: 'u',
        ü: 'u',
        ý: 'y',
        þ: 'th',
        ÿ: 'y',
        ß: 'ss',
        œ: 'oe'
      },
      formattedStr;

  formattedStr = str.replace(/[àáâäåæçèéêëìíîïðñòóôöùúûüýþÿßœ]/g, function (match) {
    return accentCorrespondence[match] || match;
  });

  return formattedStr.trim();
}

/**
 * Permet de formatter une chaîne de caractère pour l'export comptable
 * @param {string} str - Chaîne à formatter
 * @returns {string}
 * TU DONE 🗸
 */
function formatStrForAccountingExport(str) {
  var formattedStr,
      regexForSpecialChar = /[^\w\s]/g,
      $ = cheerio.load(str);

  formattedStr = $('p, div, ul, th, td')
    .first()
    .text()
    .trim() || str.trim();

  formattedStr = replaceAccents(formattedStr);

  formattedStr = formattedStr.replace(regexForSpecialChar, '');

  return formattedStr.trim()
    .toUpperCase();
}

/**
 * Encode une chaîne en Base64 (Node.js).
 * @param {string} str - Chaine à encoder
 * @returns {string} - Chaine encodée
 * TU NONEED 🧊
 */
function btoa(str) {
  return require('btoa')(str);
}

/**
 * Décode une chaîne Base64 (Node.js).
 * @param {string} str - Chaine à décoder
 * @returns {string} - Chaine décodée
 * TU NONEED 🧊
 */
function atob(str) {
  return require('atob')(str);
}

/**
 * Permet de formatter le nom d'un modèle présent dans l'URL pour le récupérer dans les modèles Sequelize
 * @param {string} modelNameInUrl - Nom du modèle dans l'url
 * @returns {string} - Nom du modèle formatté
 * TU DONE 🗸
 */
function getFormattedModelNameInUrl(modelNameInUrl) {
  return _.chain(modelNameInUrl)
    .split(/-|_/g)
    .map(_.capitalize)
    .join('')
    .value();
}


/**
 * Encode une chaîne en Base64 UTF-8.
 * Compatible avec les emojis, caractères spéciaux et textes multilignes.
 * Ce n'est PAS un chiffrement, uniquement un encodage.
 * @param {string} str - Chaîne à encoder.
 * @returns {string} Chaîne encodée en Base64.
 */
function encodeStr(str) {
  return btoa(
    encodeURIComponent(str)
      .replace(/%([0-9A-F]{2})/g, (_, p1) =>
        String.fromCharCode(`0x${ p1 }`)
      )
  );
}

/**
 * Décode une chaîne Base64 UTF-8.
 * Compatible avec les emojis et caractères spéciaux.
 * @param {string} str - Chaîne Base64 à décoder.
 * @returns {string} Chaîne décodée en UTF-8.
 */
function decodeStr(str) {
  return decodeURIComponent(
    atob(str)
      .split('')
      .map(c =>
        '%' + c.charCodeAt(0).toString(16).padStart(2, '0')
      )
      .join('')
  );
}

/**
 * Génère une chaîne de longueur totale donnée, avec un préfixe optionnel.
 * Si le préfixe dépasse la longueur demandée, il est tronqué.
 * @param {number} length - Longueur totale de la chaîne renvoyée (préfixe inclus)
 * @param {string} strToAddInFirst - Chaîne à ajouter au début
 * @returns {string} Chaîne générée
 */
function generateRandomString(length, strToAddInFirst = '') {
  var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789',
      safeLength = Number.isFinite(length) ? Math.max(0, Math.floor(length)) : 0,
      prefix = typeof strToAddInFirst === 'string' ? strToAddInFirst : '',
      randomString = '',
      randomPartLength,
      charactersLength = characters.length;

  if (!safeLength) {
    return '';
  }

  if (prefix.length >= safeLength) {
    return prefix.slice(0, safeLength);
  }

  randomPartLength = safeLength - prefix.length;

  for (var i = 0; i < randomPartLength; i++) {
    randomString += characters.charAt(Math.floor(Math.random() * charactersLength));
  }

  return `${ prefix }${ randomString }`;
}

/**
 * Permet de vérifier si une chaîne est un e-mail valide
 * @param {?string} str - Chaîne à vérifier
 * @returns {boolean} - True si la chaîne est un e-mail valide, false sinon
 */
function isEmail(str) {
  var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (!str) {
    return false;
  }

  return emailRegex.test(str);
}

module.exports = StrFormatter;